// reactStore/eventStore.js
import { create } from 'zustand'
import { getState, getGetter } from '../reactStore/vuexBridge'

export const useEventStore = create((set, get) => ({
  GTM_EVENT: ({ eventName, payload }) => {
    try {
      window.dataLayer2025 = window.dataLayer2025 || []

      // clear old ecommerce
      window.dataLayer2025.push({ ecommerce: null })

      // push event
      window.dataLayer2025.push({
        event: eventName,
        ecommerce: { ...payload }
      })
    } catch (error) {
      console.error('Failed to push GTM_EVENT:', error)
    }
  },

  GTAG_EVENT: ({ eventName, payload }) => {
    try {
      const countryId = parseInt(getState('selectedCountryAddress')?.countryId)
      payload.Country_Id = countryId

      const routeObj = window.localStorage.getItem('routeObj')
        ? JSON.parse(window.localStorage.getItem('routeObj'))
        : {}

      const defaultPayload = {
        USER_ID: getGetter('get_user_id') || 'NA',
        USER_TYPE: getGetter('get_exclusive_user'),
        SOURCE: routeObj.previous || 'NA',
        PAGE_NAME: routeObj.current || 'NA',
        UPDATED_SCHEMA: 'Yes',
        LOGGED_IN_STATUS: getGetter('authStatus') ? 'Logged In' : 'Non Logged In'
      }

      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, { ...defaultPayload, ...payload })
      }
    } catch (error) {
      console.error('Failed to push GTAG_EVENT:', error)
    }
  },

  MOENGAGE_EVENT: ({ eventName, payload }) => {
    try {
      const countryId = getState('selectedCountryAddress').countryId
      payload.Country_Id = countryId

      if (window.Moengage) {
        window.Moengage.track_event(eventName, payload)
      }
    } catch (error) {
      console.error('❌ Failed to push MOENGAGE_EVENT:', error)
    }
  }
}))



// WEBPACK FOOTER //
// ./src/react-component/reactStore/eventStore.js